import { IconButton as BaseIconButton, styled } from "@mui/material";
import { IconButtonProps } from "@mui/material/IconButton";
import { ComponentType } from "react";

export const IconButton: ComponentType<IconButtonProps> = styled(BaseIconButton)`
  opacity: 0.5;
  &:hover {
    background-color: transparent;
    opacity: 1;
  }
`;
